import React from 'react';
import Logo from "../../assets/Logo.svg";
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title"><img src={Logo} alt="" height="100" width="200"/></h1>
                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="https://gitlab.com/ArsenyCheplykov" target="_blank" rel="noopener noreferrer" className="footer__link">Projects</a>
                    </li>

                    <li>
                        <a href="#qualification" className="footer__link">Qualification</a>
                    </li>
                </ul>

                <div className="footer__social">
                    <a href="https://vk.com/light_across_eternal_void" className="home__social-icon" target="_blank">
                        <i class="uil uil-vk"></i>
                    </a>

                    <a href="https://t.me/light_across_eternal_void" className="home__social-icon" target="_blank">
                        <i class="uil uil-telegram"></i>
                    </a>

                    <a href="https://gitlab.com/ArsenyCheplyukov" className="home__social-icon" target="_blank">    
                        <i class="uil uil-gitlab"></i>
                    </a>

                    <a href="https://github.com/ArsenyCheplyukov" className="home__social-icon" target="_blank">
                        <i class="uil uil-github"></i>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;